module.exports = __webpack_public_path__ + "static/media/tg8.f06fe6ff.jpg";